import { PublicRoute, TQPSHomepage, Resources, About, Login, Contact, MapPage, ResourceLink } from './pages';
import { ProtectedRoute, OrganizationPortal, OrganizationInfo, AdminOrgs, AdminUsers, JoinRequests, Onboarding } from './pages';
import { ResourceWindow } from './components';

const routes = [
    {
        path: '',
        element: <PublicRoute />,
        children: [
            {
                index: true,
                element: <TQPSHomepage />,
            },
            {
                path: 'resources',
                element: <Resources />,
            },
            {
                path: 'about',
                element: <About />,
            },
            {
                path: 'contact',
                element: <Contact />,
            },
            {
                path: 'login',
                element: <Login />,
            },
            {
                path: 'r/:recordId',
                element: <ResourceLink />,
            },
        ],
    },
    {
        path: '',
        element: <ProtectedRoute />,
        children: [
            {
                path: 'map',
                element: <MapPage />,
            },
            {
                path: 'org_portal',
                element: <OrganizationPortal />,
            },
            {
                path: 'org_info/:orgId',
                element: <OrganizationInfo />,
            },
            {
                path: 'admin/orgs',
                element: <AdminOrgs />,
            },
            {
                path: 'admin/users',
                element: <AdminUsers />,
            },
            {
                path: 'join_requests',
                element: <JoinRequests />,
            },
            {
                path: 'onboarding',
                element: <Onboarding />,
            },
        ],
    },
    // {
    //     path: 'admin',
    //     element: <AuthedRoutes />,
    //     children: [
    //         {
    //             index: true,
    //             element: <AdminDashboard />,
    //         },
    //         {
    //             path: 'import_taxonomy',
    //             element: <ImportTaxonomy />,
    //         },
    //         {
    //             path: 'taxonomy/:id?',
    //             element: <ManageTaxonomy />,
    //         },
    //         {
];

export default routes;
